import {SaleVehiclePhotoType} from '@dms/api/settings';

import {PhotoCheckerSilhouettePart} from '../types/PhotoCheckerSilhouettePart';

const SILHOUETTE_PART_BY_PHOTO_TYPE: Partial<
  Record<SaleVehiclePhotoType, PhotoCheckerSilhouettePart>
> = {
  FRONT_LEFT: 'frontLeft',
  FRONT: 'front',
  FRONT_RIGHT: 'frontRight',
  RIGHT_SIDE: 'rightSide',
  REAR_RIGHT: 'rearRight',
  REAR: 'rear',
  REAR_LEFT: 'rearLeft',
  LEFT_SIDE: 'leftSide',
  STEERING_WHEEL: 'steeringWheel',
  FRONT_SEATS: 'frontSeats',
  BACK_SEATS: 'backSeats',
  TRUNK: 'trunk',
  INFOTAINMENT: 'infotainment',
  INSTRUMENTS_PANEL: 'dashboardTop',
};

/** The PhotoChecker silhouette part that shows a Photo Type, when the silhouette has one. */
export const getPhotoGuideSilhouettePart = (photoType: SaleVehiclePhotoType) =>
  SILHOUETTE_PART_BY_PHOTO_TYPE[photoType] ?? null;
